import { render, staticRenderFns } from "./Crud.vue?vue&type=template&id=1477a9dd&scoped=true&"
import script from "./Crud.vue?vue&type=script&lang=js&"
export * from "./Crud.vue?vue&type=script&lang=js&"
import style0 from "./Crud.vue?vue&type=style&index=0&id=1477a9dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477a9dd",
  null
  
)

export default component.exports
import {QPage,QPageSticky,QForm,QCard,QCardSection,QInput,QIcon,QPopupProxy,QDate,QSelect,QBtn,QDialog,QAvatar,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QPage,QPageSticky,QForm,QCard,QCardSection,QInput,QIcon,QPopupProxy,QDate,QSelect,QBtn,QDialog,QAvatar,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
